import { render, staticRenderFns } from "./ChangguanKzqStatBlock.vue?vue&type=template&id=e820cd48&scoped=true"
import script from "./ChangguanKzqStatBlock.vue?vue&type=script&lang=js"
export * from "./ChangguanKzqStatBlock.vue?vue&type=script&lang=js"
import style0 from "./ChangguanKzqStatBlock.vue?vue&type=style&index=0&id=e820cd48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e820cd48",
  null
  
)

export default component.exports